module.exports = __webpack_public_path__ + "img/teacher-bg.cdf53c7e.png";